import { usernameNotExistsUser } from '../../user/UserActions'

export const isRequired = (value) => {
    return value ? undefined : 'Obligatoire'
};

export const isEmail = (value) => {
    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Adresse e-mail invalide' : undefined
};

export const minLength = (min) => {
    return (value) => {
        return value && value.length < min ? `${min} caractères minimum` : undefined
    }
};

export const maxLength = (max) => {
    return (value) => {
        return value && value.length > max ? `${max} caractères maximum` : undefined
    }
};

export const exactLength = (min) => {
    return (value) => {
        return value && value.length !== min ? `Le format n'est pas valide (${min} caractères)` : undefined
    }
};

export const asyncValidateUsernameNotExists = (values, dispatch) => {
    return dispatch(usernameNotExistsUser(values))
        .then((response) => {
            var error = {};
            if (response.value.data.length > 0){
                if (response.value.data.indexOf('username') !== -1 ){
                    error["username"] = 'Cet email est déjà utilisé.'
                }
                if (response.value.data.indexOf('phone') !== -1 ){
                    error["phone"] = 'Ce numero est déjà utilisé.'
                }
                throw error;
            }
            return true
        })
};

export const asyncValidateUpdateUsername = (values, dispatch, props) => {

    if (props.provider.provider.phone !== values.phone){
        return dispatch(usernameNotExistsUser(values))
            .then((response) => {
                if (response.value.data.length > 0){
                    if (response.value.data.indexOf('phone') !== -1 ){
                        throw {phone:'Ce numero est déjà utilisé.'}
                    }
                }
                return true
            })
    }

    if(props.provider.provider.username !== values.username){
        return dispatch(usernameNotExistsUser(values))
            .then((response) => {
                if (response.value.data.length > 0){
                    if (response.value.data.indexOf('username') !== -1 ){
                        throw {username:'Cet email est déjà utilisé.'}
                    }
                }
                return true
            })
    }


    return new Promise(function(resolve){
           resolve();
        });
}



// WEBPACK FOOTER //
// ./src/utils/forms/validators.js